import { NovoRelatorioActionKeys, NovoRelatorioActionUnion } from "./action";
import { INovoRelatorioState } from "./INovoRelatorioState";

const initialState: INovoRelatorioState = {
  result: {
    data: {},
    success: true,
  },
  error: {
    data: [],
    success: false,
  },
  isLoading: false,
};

const relatoriosReducer = (
  state = initialState,
  action: NovoRelatorioActionUnion
): INovoRelatorioState => {
  switch (action.type) {
    case NovoRelatorioActionKeys.FETCH_NOVO_RELATORIO_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case NovoRelatorioActionKeys.FETCH_NOVO_RELATORIO_SUCCEEDED:
      return {
        ...state,
        result: action.payload,
        isLoading: false,
      };
    case NovoRelatorioActionKeys.FETCH_NOVO_RELATORIO_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default relatoriosReducer;
